// extracted by mini-css-extract-plugin
export var digitalItem = "index-module--digitalItem--A2H-0";
export var more = "index-module--more--+KYi1";
export var title = "index-module--title--D7tLt";